import { connect } from 'react-redux';
import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import MyAccount from './MyAccount';

export default connect(state => ({
  loggedIn: isUserLoggedIn(state),
}))(MyAccount);
